import { AccessPermissionsEnum } from '@/router/constants';

function load(component) {
  return () => import(`@/views/${component}.vue`);
}

function loadFromIndex(component) {
  return () => import(`@/views/${component}/index.js`);
}

export default [
  {
    path: 'back-office',
    name: 'back-office',
    component: load('backoffice/BackOffice'),
    meta: {
      requiresAuth: true,
      accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
      icon: 'profile-settings',
      menuItems: 'leftSideMenu.backOffice',
    },
    children: [],
  },
  {
    path: 'backoffice-clients',
    name: 'backoffice:clients',
    component: load('backoffice/clients/Clients'),
    meta: {
      requiresAuth: true,
      accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
      icon: 'agents',
      menuItems: 'leftSideMenu.backoffice.clients',
    },
    children: [],
  },
  {
    path: 'merchants',
    name: 'merchants',
    component: load('merchants/Merchants'),
    redirect: { name: 'merchants:list' },
    meta: {
      requiresAuth: true,
      accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
      icon: 'agents',
      menuItems: 'leftSideMenu.merchants',
    },
    children: [
      {
        path: 'merchants-list',
        name: 'merchants:list',
        component: load('merchants/merchantsList/MerchantsList'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
          icon: 'agents',
        },
        children: [],
      },
    ],
  },
  {
    path: 'edit-merchant/:merchantId',
    name: 'edit-merchant',
    component: load('merchants/merchantsList/EditMerchant'),
    meta: {
      requiresAuth: true,
      accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
      icon: 'profile-settings',
      menuItems: 'leftSideMenu.merchants',
    },
    children: [],
  },
  {
    path: 'add-merchant',
    name: 'add-merchant',
    component: load('merchants/merchantsList/EditMerchant'),
    meta: {
      requiresAuth: true,
      accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
      icon: 'profile-settings',
      menuItems: 'leftSideMenu.merchants',
    },
    children: [],
  },
  {
    path: 'agents',
    name: 'agents',
    component: load('agents/Agents'),
    redirect: { name: 'agents:list' },
    meta: {
      requiresAuth: true,
      accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
      icon: 'agents',
      menuItems: 'leftSideMenu.agents',
    },
    children: [
      {
        path: 'agents-list',
        name: 'agents:list',
        component: load('agents/agentsList/AgentsList'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
          icon: 'agents',
          menuItems: 'leftSideMenu.agents',
        },
        children: [],
      },
    ],
  },
  {
    path: 'agents/edit-agent/:agentId',
    name: 'edit-agent',
    component: load('agents/agentsList/EditAgent'),
    meta: {
      requiresAuth: true,
      accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
      icon: 'agents',
      menuItems: 'leftSideMenu.agents',
    },
    children: [],
  },
  {
    path: 'agents/add-agent',
    name: 'add-agent',
    component: load('agents/agentsList/EditAgent'),
    meta: {
      requiresAuth: true,
      accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
      icon: 'agents',
      menuItems: 'leftSideMenu.agents',
    },
    children: [],
  },
  {
    path: 'courses',
    name: 'courses',
    component: load('backoffice/courses/Courses'),
    meta: {
      requiresAuth: true,
      accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
      icon: 'medal-star',
      menuItems: 'leftSideMenu.courses',
    },
    children: [],
  },
  {
    path: 'education-blocks',
    name: 'education-blocks',
    component: load('backoffice/courses/eduBlocks/EducationBlocks'),
    meta: {
      requiresAuth: true,
      accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
      icon: 'medal-star',
      menuItems: 'leftSideMenu.educationBlocks',
    },
    children: [],
  },
  {
    path: 'achievements',
    name: 'achievements',
    component: load('achievements/Achievements'),
    meta: {
      requiresAuth: true,
      accessPermissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
      icon: 'medal-star',
      menuItems: 'leftSideMenu.achievements',
    },
    children: [],
  },
];
